import { CIVILITY } from '@savgroup-front-common/constants';

import { PartnerScenarioTypes } from './PartnerScenarioType';

export enum REPAIRER_TYPE {
  SUBCONTRATOR = 'Subcontrator',
  WORKSHOP = 'Workshop',
  HUB = 'Hub',
}
export interface Repairer {
  id: string;
  sellerId: string;
  repairerName: string;
  repairerType: string;
  address: {
    addressId: string;
    civility: CIVILITY;
    firstname: string;
    companyName: string;
    lastname: string;
    address: string;
    additionalAddress: string;
    additionalInformation: string;
    doorCode: string;
    floor: string;
    postalCode: string;
    city: string;
    countryCode: string;
    phone: string;
    isDefault: boolean;
    isValid: boolean;
  };
  countryCode: string;
  mailAddresses: string[];
  note: string;
  websites: string[];
  openToPublic: boolean;
  partnerScenarioType: PartnerScenarioTypes;
}
